export const environment = {
    production: false,
    apiUrl: 'https://resultsharness-qa.transnetyx.com/api',
    seqApiUrl: 'https://sequencing-qa.transnetyx.com/api/admin/internal/mock-data',

    auth0: {
        domain: 'login-qa.transnetyx.com',
        clientId: 'YCNRnF1beUlAbkb6KKGWajuaq98XRIyY',
        redirectUri: `${window.location.origin}`,
        logoutReturnUrl: `https://accounts-qa.transnetyx.com/v2/logout/order-manager`,
        logoutUrl: 'https://login-qa.transnetyx.com/v2/logout',
    },

    omUrl: 'http://ordermanager-dev.transnetyx.com/Default.aspx',
    omOrderResultsUrl: 'https://ordermanager-qa.transnetyx.com/Orders/OrderResults.aspx?OrderId=',
    seqOrderDetailsPageUrl: 'https://yxadmin-qa.transnetyx.com/sequencing/orders/details/',
    qoOrderSetupStrainSelectionUrl: 'https://quickorder2-qa.transnetyx.com/order-setup/strain-selection',
};
